exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-hover[data-v-4c6dac93]:hover{background-color:#f5f5f5}", ""]);

// exports
